/**
 * SEO Component - Reusable Helmet wrapper for landing pages
 * Provides consistent meta tags, canonical URLs, and structured data
 */
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  canonical,
  type = 'website',
  structuredData = null
}) => {
  const fullTitle = title.includes('ReviewResponder') ? title : `${title} | ReviewResponder`;
  const canonicalUrl = canonical ? `https://tryreviewresponder.com${canonical}` : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
